import "./TadSheetFieldSchema";
import "./TadSheetReferredFrom";

import {
  FirestoreCollectionProsessorOptions,
  createFirestoreCollectionProsessor,
} from "../firebase/firestore";

export type TadSheet = {
  id: string;
  name: string;
  displayName: string;
  description: string | null;
  /** 時間軸カラムの表示名。機械向けの名前は予約語 `time_col` に固定されている。 */
  timeColDisplayName: string;
  createdAt: string;
  updatedAt: string;
  isDisabled: boolean;
};

type TadSheetRaw = {
  id: string;
  name: string;
  display_name: string;
  description: string | null;
  time_col_display_name: string;
  created_at: string;
  updated_at: string;
  is_disabled: boolean;
};

/** 時間軸カラムの機械向け名(予約語)。シートフィールドスキーマはこの名前を使えない。 */
export const TAD_SHEET_TIME_COL_NAME = "time_col";

const processorOptions: FirestoreCollectionProsessorOptions<
  TadSheet,
  TadSheetRaw,
  Record<string, string>
> = {
  getCollectionPath: ({ organizationId }) =>
    `/app/spreadsheet_ui/v/1/organizations/${organizationId}/tad_sheets`,
  toFirestore: ({
    id,
    name,
    displayName,
    description,
    timeColDisplayName,
    createdAt,
    updatedAt,
    isDisabled,
  }) => ({
    id,
    name,
    display_name: displayName,
    description,
    time_col_display_name: timeColDisplayName,
    created_at: createdAt,
    updated_at: updatedAt,
    is_disabled: isDisabled,
  }),
  fromFirestore: ({
    id,
    name,
    display_name,
    description,
    time_col_display_name,
    created_at,
    updated_at,
    is_disabled,
  }) => ({
    id,
    name,
    displayName: display_name,
    description,
    timeColDisplayName: time_col_display_name,
    createdAt: created_at,
    updatedAt: updated_at,
    isDisabled: is_disabled,
  }),
};

export const {
  useGetAll: useGetTadSheets,
  useGet: useGetTadSheet,
  useItem: useTadSheet,
  useItems: useTadSheets,
  useItemsQuery: useTadSheetsQuery,
} = createFirestoreCollectionProsessor(processorOptions);
